import { ISpecification, ISpecificationType } from 'app/services/specification';
import { IList } from 'app/shared';
import { SpecificationActionTypes, SET_SPECIFICATIONS, SET_SPECIFICATION, SET_SPECIFICATION_TYPES } from './types';

/**
 * Global olarak bulunan Spesifikasyon Datasını Set Eder.
 */
export function setSpecifications(specifications: IList<ISpecification[]>): SpecificationActionTypes {
    return {
        type: SET_SPECIFICATIONS,
        specifications
    }
}

/**
 * Global olarak bulunan Spesifikasyon Tipleri Datasını Set Eder.
 */
export function setSpecificationTypes(specificationTypes: IList<ISpecificationType[]>): SpecificationActionTypes {
    return {
        type: SET_SPECIFICATION_TYPES,
        specificationTypes
    }
}

/** 
 * Global olarak bulunan Spesifikasyon Objesini Set Eder.
 */
export function setSpecification(specification: ISpecification): SpecificationActionTypes {
    return {
        type: SET_SPECIFICATION,
        specification
    }
}